export const QA_VMS = ['vm200', 'vm201', 'vm286'];

export const getQaRuntimeVM = () => {
  const match = window.__runtimeDomains?.find((domain: { domain: string }) =>
    QA_VMS.some((vm) => domain.domain.includes(vm))
  );
  return match && QA_VMS.find((vm) => match.domain.includes(vm));
};

export const isQaRuntime = () => getQaRuntimeVM() !== undefined;

export const applyQaVMHack = (tld: string) => {
  const isQA = typeof window === 'undefined' ? process.env.IS_QA === 'true' : isQaRuntime();

  if (isQA) {
    const index = tld.indexOf('.');
    if (index > 0) {
      return tld.substring(0, index) + '.v' + tld.substring(index + 1);
    }
    return 'v' + tld;
  }
  return tld;
};
